// Main theme entry point
// Imports and initializes all theme modules

console.log('Theme: Loading theme modules...');

// Import core utilities (assumed to be available globally)
console.log('Theme: Core utilities loaded');

// Import and initialize cart functionality
console.log('Theme: Loading cart functionality...');

// Import and initialize product functionality
console.log('Theme: Loading product functionality...');

// Import and initialize collection functionality
console.log('Theme: Loading collection functionality...');

// Theme initialization
function initTheme() {
  console.log('Theme: Initializing theme...');

  // All initialization is handled by individual modules
  // This serves as the main entry point

  console.log('Theme: Theme initialization complete');
}

// Initialize theme when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTheme);
} else {
  initTheme();
}

console.log('Theme: Theme loading complete');

// Export for potential use by other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    initTheme
  };
}
